module.exports = __webpack_public_path__ + "media/configurations/SV_P-X-X-X-X-P-d18e7aa2.png";